// state.js

export default {
    currentUser: {
        id: 0,
        name: "",
        email: "",
        email_verified_at: null,
        created_at: "",
        updated_at: "",
        role_id: 1,
        role_code: ""
    },
};
